import React, { useState } from 'react';
import Sidebar from './Sidebar';
import RightSidebar from './RightSidebar';
import BottomNav from './BottomNav';
import CreateMenu from './CreateMenu';
import Footer from './Footer';
import Navbar from './Navbar';
import { useAuth } from '../context/AuthContext';
import { canManagePlatform } from '../utils/permissions';
import { cn } from '../utils';

const Layout = ({ children, hideSidebars = false, sidebar: CustomSidebar }) => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { user } = useAuth();
  const isPlatformAdmin = canManagePlatform(user);

  return (
    <div className="flex h-screen overflow-hidden bg-brand-light font-sans selection:bg-brand-indigo/10 selection:text-brand-indigo">
      {/* Desktop Left Sidebar */}
      {!hideSidebars && (
        <div className="hidden md:block shrink-0">
          {CustomSidebar ? CustomSidebar : <Sidebar onCreateClick={() => setIsCreateOpen(true)} />}
        </div>
      )}

      {/* Mobile Custom Sidebar Overlay */}
      {!hideSidebars && CustomSidebar && (
        <div className={cn(
          "fixed inset-0 z-[100] md:hidden transition-all duration-300",
          isMobileSidebarOpen ? "visible" : "invisible"
        )}>
          <div 
            className={cn(
              "absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity duration-300",
              isMobileSidebarOpen ? "opacity-100" : "opacity-0"
            )}
            onClick={() => setIsMobileSidebarOpen(false)}
          />
          <div className={cn(
            "absolute left-0 top-0 bottom-0 w-80 bg-white transition-transform duration-300 ease-out",
            isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
          )}>
            {/* Clone the sidebar but ensure it doesn't have the fixed class that might break it or similar */}
            {React.cloneElement(CustomSidebar, { isMobile: true, onClose: () => setIsMobileSidebarOpen(false) })}
          </div>
        </div>
      )}

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col min-w-0">
        <Navbar onMenuClick={() => setIsMobileSidebarOpen(true)} hasCustomSidebar={!!CustomSidebar} />
        <div className="flex-1 overflow-y-auto scroll-smooth relative">
          <div className="min-h-full flex flex-col">
            <div className="flex-1 pb-32 md:pb-8 relative">
              {/* Subtle Background Pattern */}
              <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:32px_32px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20 pointer-events-none"></div>
              
              <div className="relative z-10 animate-in fade-in duration-500">
                {children}
              </div>
            </div>
            {!hideSidebars && <Footer />}
          </div>
        </div>
      </main>

      {/* Desktop Right Sidebar */}
      {!isPlatformAdmin && !hideSidebars && (
        <div className="hidden lg:block shrink-0">
          <RightSidebar />
        </div>
      )}

      {/* Mobile Bottom Navigation */}
      <BottomNav onCreateClick={() => setIsCreateOpen(true)} />

      {/* Create Overlay */}
      {!isPlatformAdmin && <CreateMenu isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)} />}
    </div>
  );
};

export default Layout;
